import $store from '../store';

const getMFL = (risk) => {
  let mfl = 0;
  if (risk.impactos) {
    risk.impactos.forEach((impacto) => {
      if (impacto.mfl > mfl) {
        mfl = impacto.mfl;
      }
    });
  }
  return mfl;
};

const findRootArea = area => (area.area_padre && findRootArea(area.area_padre)) || area;

const canReviewRisk = ({
  user,
  risk,
  contract,
  actualProfile,
  statusStep,
  workflows,
}) => {
  try {
    // Ya no en revisión
    if (parseInt(risk.status, 10) !== 0) return false;

    // Coordinador editando
    if (parseInt(risk.status_step, 10) === -1) return false;

    // Casos segun MFL
    const mfl = parseInt(getMFL(risk));
    if (mfl === 0) return false;

    const workflow = workflows[risk.tipo && risk.tipo.toLowerCase()];

    if (!workflow) {
      // console.error(`workflows no trae riesgo de tipo ${risk.tipo.toLowerCase()}`);
      return false;
    } // if
    const steps = workflow.risks[mfl - 1];
    // statusStep se puede enviar otra para saber si en el futuro un usuario debera evaluar
    const CurrentStep = steps[statusStep || risk.status_step];
    // no hay siguiente paso
    if (!CurrentStep) return false;

    const statusStepApprovedByProfiles = risk.status_step_approved_by_profiles || [];
    const reviewer = contract.revisores;
    // si se encuentra al usuario en la lista para evaluar en este paso
    let resp = CurrentStep.peopleProfile.some(
      // los revisores traen array y lo de area son objetos(no pueden find)
      p => p === actualProfile
        && reviewer[p]
        && reviewer[p].find
        && reviewer[p].find(uId => uId === user._id)
    );
    // caso de areas, 'general_manager'
    const { area } = contract;
    const rootArea = area && findRootArea(area);
    const generalManager = rootArea && rootArea.manager_id === user._id;

    const rolId = actualProfile === 'general_manager'
      ? 'manager_id'
      : `${actualProfile}_id`;

    resp = resp || (
      area
      && area[rolId] === user._id // si le corresponde evaluar al usuario
      && CurrentStep.peopleProfile.includes(actualProfile) // si le corresponde evaluar al perfil
    );

    resp = resp || (
      generalManager // si el usuario actual es el gerente general
      && CurrentStep.peopleProfile.includes('general_manager') // si le corresponde evaluar al gerente general
    );

    // si el usuario no tiene el perfil para evaluar en este paso
    if (!resp) return false;

    // si el perfil ya evaluo
    return !statusStepApprovedByProfiles.find(savedP => savedP === actualProfile);
  } catch (e) {
    console.log(e);
    return false;
  }
}; // canChangeStatus

const canChangeRisk = ({ risk, profile }) => {
  if (
    risk.custom
    && (parseInt(risk.status) === 0
    || parseInt(risk.status) === -1)
    && parseInt(risk.status_step) === -1
    && (profile === 'coordinator'
      || profile === 'contractor_coordinator')
  ) {
    return true;
  }
  return false;
}; // canChangeRisk

const findArea = (_id) => {
  try {
    return $store.getters.areas.find(a => a._id === _id);  
  } catch (e) {
    console.error(e);
    return {};
  }
}; // findArea

const findWorkflow = (_id) => {
  try {
    return $store.getters.workflows.find(w => w._id === _id);
  } catch (e) {
    // console.error(e);
    return {};
  }
}; // findWorkflow

const isRiskReady = (risk) => {
  const errors = [];
  if (risk && risk.custom === true) {
    // Verifica que exista nombre en el riesgo
    if (risk.nombre === '') {
      errors.push(
        `${this.$t('Riesgo')} "${risk.nombre}" ${this.$t(
          'no tiene un nombre asociado',
        )}`,
      );
    }
    // Verifica que exista nombre en el riesgo
    if (risk.tipo === null) {
      errors.push(
        `${this.$t('Riesgo')} "${risk.nombre}" ${this.$t(
          'no tiene un tipo asociado',
        )}`,
      );
    }
    // Verifica que existan causas en el riesgo
    if (!risk.causas || risk.causas.length === 0) {
      errors.push(
        `${this.$t('Riesgo')} "${risk.nombre}" ${this.$t(
          'no tiene causas asociadas',
        )}`,
      );
    }
    // Verificar que existan impactos en el riesgo
    if (!risk.impactos || risk.impactos.length === 0) {
      errors.push(
        `${this.$t('Riesgo')} "${risk.nombre}" ${this.$t(
          'no tiene impactos asociados',
        )}`,
      );
    }
    // Verifica que todas las causas tengan controles preventivos
    if (risk.causas.length > 0) {
      risk.causas.forEach((causa) => {
        if (
          !causa.controles_preventivos
          || causa.controles_preventivos.length === 0
        ) {
          errors.push(
            `Riesgo "${risk.nombre}", ${this.$t('Causa')} '${
              causa.nombre
            }' ${this.$t('no tiene controles preventivos asociados')}`,
          );
        }
      });
    } else {
      errors.push(
        `${this.$t('Riesgo')} "${risk.nombre}" ${this.$t(
          'no tiene controles preventivos asociados',
        )}`,
      );
    }

    // Si es MFL < 3, no es necesario agregar controles mitigadores
    // Verifica que todos los impactos tengan controles mitigadores
    const mfl = getMFL(risk);
    if (mfl === 0) {
      errors.push(
        `Riesgo "${risk.nombre}", ${this.$t('Impacto')} ${this.$t(
          'no tiene controles mitigadores asociados',
        )}`,
      );
    } else if (mfl > 2) {
      risk.impactos.forEach((impacto) => {
        if (
          !impacto.controles_mitigadores
          || impacto.controles_mitigadores.length === 0
        ) {
          errors.push(
            `Riesgo "${risk.nombre}", ${this.$t('Impacto')} '${
              impacto.categoria
            }' ${this.$t('no tiene controles mitigadores asociados')}`,
          );
        }
      });
    }

    // Valida Equipo Evaluador
    /* if (!risk.evaluadores || risk.evaluadores.length === 0) {
      errors.push(
        `${this.$t('Riesgo')} "${risk.nombre}" ${this.$t(
          'no tiene ningún evaluador',
        )}`,
      );
    } */
    // Valida escenarios
    /* if (!risk.escenario || risk.escenario === '') {
      errors.push(
        `${this.$t('Riesgo')} "${risk.nombre}" ${this.$t(
          'no tiene escenario',
        )}`,
      );
    } */
    //medioambiente
    /* if (risk.tipo === 'medioambiente') {
      if (!risk.medioambiente.responsable) {
        errors.push(
          `${this.$t('Riesgo')} "${risk.nombre}" ${this.$t(
            'no tiene responsable',
          )}`,
        );
      }

      if (!risk.medioambiente.evento) {
        errors.push(
          `${this.$t('Riesgo')} "${risk.nombre}" ${this.$t(
            'no tiene evento',
          )}`,
        );
      }

      if (!risk.medioambiente.condicion) {
        errors.push(
          `${this.$t('Riesgo')} "${risk.nombre}" ${this.$t(
            'no tiene condición',
          )}`,
        );
      }

      if (!risk.medioambiente.equipo) {
        errors.push(
          `${this.$t('Riesgo')} "${risk.nombre}" ${this.$t(
            'no tiene equipo crítico',
          )}`,
        );
      }
    } */

    if (errors.length > 0) {
      return { status: false, errors };
    }
    return { status: true, errors };
  }
  return { status: true, errors };
}; // isRiskReady

const iframeMessages = (callB) => {
  if (window.addEventListener) {
    window.addEventListener('message', callB, false);
  } else {
    window.attachEvent('onmessage', callB);
  }
}; // iframeMessages

export {
  iframeMessages,
  isRiskReady,
  getMFL,
  canReviewRisk,
  canChangeRisk,
  findRootArea,
  findArea,
  findWorkflow,
};
